import './OrderFrequency.css';

const OrderFrequency: React.FC = ({ children }) => {
	return <div className='order-frequency-wrapper'>{children}</div>;
};

export default OrderFrequency;
